import React, { createContext, useState, useContext } from 'react';

const HrmContext = createContext();

export const useHRM = () => useContext(HrmContext);

export const HRMProvider = ({ children }) => {
    const [payrollType, setPayrollType] = useState(localStorage.getItem('payrollType') || 'F');

    return <HrmContext.Provider value={{ payrollType, setPayrollType }}>{children}</HrmContext.Provider>;
};
